<template>
    <!--烟感报警-->
    <div class="smokeAlarm">
       <el-row :gutter="32">
            <el-col :span="19" :offset="4">
                <div class="smokeSend">
                    <img src="~@/assets/img/smokeSend.png" alt="" style="width:10%;vertical-align: middle;">
                    烟感报警调度派单</div>
            </el-col>
        </el-row> 
       <el-row :gutter="32">
            <el-col :span="3">
                <el-steps direction="vertical" :active="active" style="height:calc(50vh);">
                    <el-step title="接警"></el-step>
                    <el-step title="调度派单"></el-step>
                    <el-step title="火场文书"></el-step>
                </el-steps>
            </el-col>
            <el-col :span="21">
                <div v-if="active === 1">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>报警信息</span>
                        </div>
                        <div class="cardTitle"> 
                            <div class="cardTitleItem">{{alarmInfo.alarmSingle.alarmTime}}</div>
                            <div class="cardTitleItem">{{alarmInfo.smokeEquipmentDO.address}}</div>
                            <div class="cardTitleItem">{{alarmInfo.smokeEquipmentDO.equipmnetName}} | {{alarmInfo.smokeEquipmentDO.phone}} <div class="cardTitleItemBtn"><el-button size="small" @click="callPhone(alarmInfo.smokeEquipmentDO.phone)" type="primary">立即呼叫</el-button></div></div>
                            <div class="cardTitleItem" v-if="alarmInfo.smokeEquipmentDO.equipmnetNametwo != null">{{alarmInfo.smokeEquipmentDO.equipmnetNametwo}} | {{alarmInfo.smokeEquipmentDO.phonetwo}}<div class="cardTitleItemBtn"> <el-button size="small" @click="callPhone(alarmInfo.smokeEquipmentDO.phonetwo)" type="primary">立即呼叫</el-button></div></div>
                            <div class="cardTitleItem">{{alarmInfo.smokeEquipmentDO.urgencyName}} | {{alarmInfo.smokeEquipmentDO.urgencyPhone}}<div class="cardTitleItemBtn"> <el-button size="small" @click="callPhone(alarmInfo.smokeEquipmentDO.urgencyPhone)" type="primary">立即呼叫</el-button></div></div>
                        </div>
                    </el-card>
                    <div class="bottomBtn">
                        <el-row :gutter="32">
                            <el-col :span="7">
                                <el-button style="background-color:rgba(85, 85, 85, 1)" @click="falseAlarm">设备误报</el-button>
                            </el-col>
                            <el-col :span="8" :offset="1">
                                <el-button style="background-color:rgba(0, 103, 176, 1)">暂时关闭烟感</el-button>
                            </el-col>
                            <el-col :span="7" :offset="1">
                                <el-button style="background-color:rgba(202, 44, 104, 1)" @click="dispatchOrder">出警派单</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div v-if="active === 2">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>报警信息</span>
                        </div>
                        <div class="cardTitle"> 
                            <el-row :gutter="32">
                                <el-col :span="12">
                                    <div class="cardTitleItem">
                                       <img src="~@/assets/img/time.svg" alt="" style="vertical-align: middle;">
                                        {{alarmInfo.alarmSingle.alarmTime}}
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="cardTitleItem">
                                        <img src="~@/assets/img/address.svg" alt="" style="vertical-align: middle;">
                                        {{alarmInfo.smokeEquipmentDO.address}}
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>选择出警队员</span>
                        </div>
                        <div class="cardTitle"> 
                            <el-checkbox-group v-model="selectCjPersons">
                                <el-row :gutter="32">
                                    <el-col :span="4" v-for="(item,index) in cjPersons" :key="index" >
                                        <el-checkbox :label="item" :key="item.id">{{item.name}}</el-checkbox>
                                    </el-col>
                                </el-row>
                            </el-checkbox-group>
                        </div>
                    </el-card>
                    <el-card class="box-card">
                        <div slot="header" class="clearfix" v-if="selectEquip">
                            <span>请选择出警装备及数量</span>
                        </div>
                        <div class="cardTitle" v-if="selectEquip"> 
                            <el-checkbox-group v-model="selectEqus">
                                <el-row :gutter="32">
                                    <el-col :span="6" v-for="(item,index) in equs" :key="index">
                                        <el-checkbox :label="item" :key="item.id">{{item.ename}}</el-checkbox>
                                        <el-input-number v-model="item.num" :step="1" size="small" :min="0" style="margin-left:5px;"></el-input-number>   
                                    </el-col>
                                </el-row>
                            </el-checkbox-group>
                        </div>
                        <div class="bottomBtn">
                            <el-row :gutter="32">
                                <el-col :span="18" :offset="3">
                                    <el-button type="primary" @click="police">出警</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </div>
                <div v-if="active === 3">
                    <fireBook ref="fireBook" :selectRow="selectRow" @closeSmokeAlarm="closeSmokeAlarm"></fireBook>
                </div>
                <el-dialog title="" :visible.sync="dialogVisible" width="30%" append-to-body center show-close>
                    <div class="tip">
                        请根据实际情况输入处警异常结束的原因
                    </div>
                    <div>
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="falseContent"></el-input>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitFalseContent">提 交</el-button>
                    </span>
                </el-dialog>
            </el-col>
        </el-row> 
    </div>
</template>
<script>
import fireBook from '@/pages/fireBook/fireBook'
export default {
    components:{
        fireBook
    },
    props:['alarmId'],
    data(){
        return{
            active: this.$store.state.smokeAlarmActive,
            selectRow: {id:this.alarmId},
            dialogVisible: false,
            falseContent: '',
            alarmInfo: {},
            selectCjPersons:[],
            selectEqus: [],
            equs: [],
            cjPersons: [],
            selectEquip: true
        }
    },
    created(){
        let _this = this;
        if(!_this.active){
            _this.active = 1;
            _this.selectEquip = true;
        }
        if(_this.active === 2){
            _this.handleSearch();
            _this.selectEquip = false;
        }
        _this.queryFireBook();
        _this.queryEquipInfo();
    },
    methods:{
        closeSmokeAlarm(){
            let _this = this;
            _this.$emit("closeSmokeAlarm");
        },
        handleSearch(){
            let _this = this;
            var success = function(resp){
                _this.cjPersons = resp.userDOList;
                resp.equipment.forEach(function(item){
                    item.num = 0;
                    _this.equs.push(item);
                });
            }
            _this.http.get('/webapi/writ/isMisdeclaration/'+ _this.alarmId,{},success);
        },
        callPhone(phone){
            let _this = this;
            var success = function(resp){
                if(!resp.code === '0'){
                    _this.$message.warning("呼叫失败！");
                }
            }
            _this.http.post('/webapi/writ/voiceCalls',{phone:phone},success);
        },
        queryEquipInfo(){
            let _this = this;
            let success = function(resp){
                _this.alarmInfo = resp;
            }
            _this.http.get('/webapi/alarmSmoke/'+_this.alarmId,{},success);
        },
        submitFalseContent(){
            let _this = this;
            if(_this.falseContent === ''){
                _this.$message.warning("请输入误报信息！");
                return;
            }
            var success = function(resp){
                if(resp.code === '0'){
                    _this.$message.success("设备误报成功！");
                    setTimeout(function(){
                        _this.dialogVisible = false;
                        _this.$emit('closeSmokeAlarm');
                    },500);
                }
            }
            _this.http.post('/webapi/writ/yesMisdeclaration',{content:_this.falseContent,id:_this.alarmId},success);
        },
        falseAlarm(){//设备误报
            let _this = this;
            _this.dialogVisible = true;
        },
        dispatchOrder(){
            let _this = this;
            _this.handleSearch();
            // _this.$store.commit('updateSmokeAlarmActive',_this.active++);
        },
        police(){
            let _this = this;
            _this.dispatchOrder2();
        },
        dispatchOrder2(){
            let _this = this;
            if(_this.selectEquip && _this.selectCjPersons.length <= 0){
                _this.$message.warning("请选择出警人员")
                return;
            }
            if(_this.selectEquip && _this.selectEqus.length <= 0){
                _this.$message.warning("请选择装备")
                return;
            }
            _this.selectEqus.forEach(function(item){
                if(item.num === 0){
                    _this.$message.warning("已选装备数量不能为0");
                    return ;
                }
            })
            var alarmCommanderIds = _this.selectCjPersons.map(item =>{
                return item.id;
            });
            var equipmentIds = _this.selectEqus.map(item =>{
                return item.id;
            });
            var equipmentNumbers = _this.selectEqus.map(item =>{
                return item.num;
            });
            var data = {
                id:_this.alarmId,
                alarmCommanderIds:alarmCommanderIds.join(),
                equipmentIds: equipmentIds.join(),
                equipmentNumbers: equipmentNumbers.join()
            }
            var success = function(resp){
                if(resp.code === '0'){
                    _this.$store.commit('updateSmokeAlarmActive',_this.active++);
                    _this.$store.commit('updateSelectFireBookActive','first');
                }
            }
            _this.http.post('/webapi/writ/goPoliceAdd',data,success);
        },
        queryFireBook(){//查询火场文书
            let _this = this;
            var success = function(resp){
                _this.selectRow.queryFireBook = resp;
                _this.selectRow.audit = '1';
                _this.selectRow.idStr = _this.idStr;
            }
            _this.http.get('/webapi/alarmSmoke/'+_this.alarmId,{},success);
        }
    }
}
</script>
<style lang="less" scoped>
// .smokeAlarm{
//     height:100%;
//     .el-row{
//         .el-col{
//             .smokeSend{
                
//                 font-size: 28px;
//                 color:rgb(53, 151, 187);
//                 padding:14px 0;
//                 margin-bottom: 10px;
//                 text-align: center;
//                 border-top:1px dashed rgb(215, 215, 215);
//                 border-bottom:1px dashed rgb(215, 215, 215);
                
//             }
//             .el-steps{
//                 margin-left: 40px;
//             }
//             .el-card{
//                 margin: 0 50px;
//                 .el-card__header{
//                     text-align: center;
//                     background-color: rgba(29, 69, 138, 1);
//                     color: white;
//                 }
//                 .cardTitle{
//                     padding-top: 10px;
//                     .cardTitleItem{
//                         line-height: 32px;
//                          padding: 10px;
//                         .cardTitleItemBtn{
//                             float: right;
//                             margin-right: 50%;
//                         }
//                     }
//                 }
//             }
//             .bottomBtn{
//                 margin: 10px 50px 0px 50px;
//                 .el-row{
//                     .el-col{
//                         height: 70px !important;
//                         .el-button{
//                             width: 100%;
//                             height: 70% !important;
//                             padding: 5px 0 5px 20px;
//                             height: 100%;
//                             font-size: 18px;
//                             font-weight: 700;
//                             font-weight: 700;
//                             color: #FFFFFF;
//                         }
//                     }
//                 }
//             }
//         }
//     }
// }
// .tip{
//     font-size: 18px;
//     line-height: 40px;
// }
.smokeAlarmAuto{
    .policeInfo{
        width: 842px;
        margin:auto;
        margin-top:18px;
        border: 1px solid #FFFFFF;
        border-radius: 10px;
        .policeInfoTop{
            text-align: center;
            height: 60px;
            line-height: 60px;
            border-bottom:1px solid #fff; 
            position: relative;
            .policeNum{
                text-align: right;
            }
            .policeText{
                text-align: left;
            }

        }
           .lineHei{
                line-height: 32px;
                font-size: 20px;
                color:#fff;
            }
        .policeInfoBot{
              padding:10px 0 10px 43px;
              .el-form-item{
                  margin:0;
              }
            .piBot{
                span{
                    line-height: 46px;
                }
                .piTopText{
                    margin:0 30px 0 10px;
                    color:#fff;
                    font-size: 18px;
                }
            }
            .piTopImg{
                vertical-align: middle;
            }
            .piBtn{
                width: 132px;
                height: 39px;
                border: 1px solid #FFFFFF;
                border-radius: 20px;
                background: transparent;
                color:#fff;
                margin-bottom:6px;
                margin-right: 23px;
            }
            .el-input{
               width:156px;
                height:32px;
               border-radius: 10px;
            }
            .el-textarea__inner{
               border-radius: 10px;
            }
        }
    }
    .policeSub{
        text-align: center;
        margin-top:20px;
    }
  
}
</style>


// WEBPACK FOOTER //
// src/pages/alarm/smokeAlarm.vue